// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__ylczG","card":"Login_card__1z8b0"};